import React, { useContext, cloneElement } from 'react'
import { Provider } from 'react-redux'
import {
  Loader,
  Login as LogIn,
  Logout as LogOut,
  idpPath,
  IDP,
  AppContext
} from '@ctsu/loader'

import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes
} from 'react-router-dom'

import AppRoutes from 'routes'
import LoginHolder from 'components/LoginHolder'
import Layout from 'components/Layout'
import CTSUErrorBoundary from 'components/ErrorBoundary'
import history from 'stores/store';

function Loading() {
  return <div>...Loading</div>;
}

function Login() {
  return <LoginHolder>
    <LogIn page={<Navigate to="/" />} />
  </LoginHolder>
}

function Logout() {
  return <LogOut logout={<Navigate to="/" />} />
}

function GotoLogin() {
  return <Navigate to="/login" />
}

function Protect({ element }) {
  const context = useContext(AppContext);
  const { session } = context;
  const authenticated = session && session.username
  if (authenticated) {
    // return children;
    return <>{cloneElement(element, {})}</>
  }
  return <GotoLogin />;
};

function App() {
  return <Provider store={window.BIStoreHandler.InitStore()}>
    <Loader loadIndicator={<Loading />}>
      <Router history={history}>
        <CTSUErrorBoundary>
          <Layout>
            <Routes>
              {AppRoutes.map(({ path, exact, element }) => (
                <Route
                  key={path}
                  exact={exact}
                  path={path}
                  element={<Protect element={element} />}
                />
              ))}
              <Route exact path="/logout" element={<Logout />} />
              <Route exact path={idpPath} element={<IDP />} />
              <Route exact path="/login" element={<Login />} />
            </Routes>
          </Layout>
        </CTSUErrorBoundary>
      </Router>
    </Loader>
  </Provider>
}

export default App;